import React from "react";

export default function Privacypolicy() {
  return (
    <>
      <div className="container py-5">
        <h1 className="text-center heading mb-4">Privacy & Refund Policy</h1>

        <h2 className="mt-4 privacy-heading">Who We Are</h2>
        <p className="privacy-text">
          Our website address is:{" "}
          <a
            href="https://mentationtech.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://mentationtech.in/
          </a>
        </p>

        <h2 className="mt-4 privacy-heading">
          What Personal Data We Collect and Why We Collect It
        </h2>
        <p className="privacy-text">
          Mentation Technologies collects personal data to provide and improve
          our services, communicate with clients, and ensure a secure and
          customized experience.
        </p>

        <h2 className="mt-4 privacy-heading">Comments</h2>
        <p className="privacy-text">
          When visitors leave comments on the site, we collect the data shown in
          the comments form, along with the visitor’s IP address and browser
          user agent string to help with spam detection. Your profile picture
          may be visible alongside approved comments.
        </p>

        <h2 className="mt-4 privacy-heading">Media</h2>
        <p className="privacy-text">
          If you upload images to our website, please avoid including embedded
          location data (EXIF GPS). Visitors can download images, so be mindful
          of any sensitive data.
        </p>

        <h2 className="mt-4 privacy-heading">Contact Forms</h2>
        <p className="privacy-text">
          We collect personal data submitted via contact forms to respond to
          inquiries and provide support.
        </p>

        <h2 className="mt-4 privacy-heading">Cookies</h2>
        <p className="privacy-text">
          Cookies may be used to remember your preferences and improve website
          functionality. Login and session cookies are used to provide a
          seamless experience and are removed upon logout or expiration.
        </p>

        <h2 className="mt-4 privacy-heading">
          Embedded Content from Other Websites
        </h2>
        <p className="privacy-text">
          Content embedded from other websites behaves as if you visited that
          website directly. Mentation Technologies is not responsible for
          external website content.
        </p>

        <h2 className="mt-4 privacy-heading">Analytics</h2>
        <p className="privacy-text">
          We use analytics tools to understand user behavior and improve our
          services.
        </p>

        <h2 className="mt-4 privacy-heading">Who We Share Your Data With</h2>
        <p className="privacy-text">
          Personal data is not shared with third parties except to provide
          services, comply with legal obligations, or for business operations.
        </p>

        <h2 className="mt-4 privacy-heading">How Long We Retain Your Data</h2>
        <p className="privacy-text">
          Comments and their metadata may be retained indefinitely. Registered
          users can view, edit, or delete their personal data at any time
          (except usernames).
        </p>

        <h2 className="mt-4 privacy-heading">Your Rights</h2>
        <p className="privacy-text">
          You can request access to, correction of, or deletion of your personal
          data, subject to legal and operational requirements.
        </p>

        <h2 className="mt-4 privacy-heading">Where We Send Your Data</h2>
        <p className="privacy-text">
          Automated systems may check comments and submissions to prevent spam
          or abuse.
        </p>

        <h2 className="mt-4 privacy-heading">Your Contact Information</h2>
        <p className="privacy-text">
          Please contact us at <strong>support@mentationtech.in</strong> for any
          privacy-related queries.
        </p>

        <h2 className="mt-4 privacy-heading">How We Protect Your Data</h2>
        <p className="privacy-text">
          We implement strong technical and organizational measures to protect
          personal data against unauthorized access, loss, or misuse.
        </p>

        <h2 className="mt-4 privacy-heading">Data Breach Procedures</h2>
        <p className="privacy-text">
          In the event of a data breach, we notify affected users promptly and
          take corrective measures to mitigate risks.
        </p>

        <h2 className="mt-4 privacy-heading">Third-Party Data Sources</h2>
        <p className="privacy-text">
          We may receive limited data from analytics and business service
          providers.
        </p>

        <h2 className="mt-4 privacy-heading">
          Automated Decision-Making and Profiling
        </h2>
        <p className="privacy-text">
          Mentation Technologies does not perform automated decision-making or
          profiling based on personal data.
        </p>

        <h2 className="mt-4 privacy-heading">Regulatory Compliance</h2>
        <p className="privacy-text">
          We comply with applicable data privacy laws and industry standards to
          safeguard user information.
        </p>

        <h2 className="mt-5 privacy-heading">Refunds & Cancellations Policy</h2>
        <p className="privacy-text">
          Customer satisfaction is important to Mentation Technologies. Below
          are our refund and cancellation policies:
        </p>

        <h2 className="mt-4 privacy-heading">Order Cancellation</h2>
        <p className="privacy-text">
          Orders may be cancelled before processing or delivery. Contact us at
          <a href="mailto:sales@mentationtech.in">
            {" "}
            sales@mentationtech.in
          </a>{" "}
          immediately.
        </p>

        <h2 className="mt-4 privacy-heading">Service Cancellation</h2>
        <p className="privacy-text">
          Cancellations must be requested at least 12 hours in advance. Late
          cancellations may incur fees.
        </p>

        <h2 className="mt-4 privacy-heading">Refund Eligibility</h2>
        <p className="privacy-text">
          Refunds are issued for eligible cancellations, defective products, or
          misrepresented services. Requests must be submitted within 10 days of
          delivery or completion.
        </p>

        <h2 className="mt-4 privacy-heading">Refund Processing</h2>
        <p className="privacy-text">
          Approved refunds are processed within 5–7 working days via the
          original payment method.
        </p>

        <h2 className="mt-4 privacy-heading">Partial Refunds</h2>
        <p className="privacy-text">
          Partial refunds may be provided at our discretion based on the
          circumstances.
        </p>

        <h2 className="mt-4 privacy-heading">
          How to Request a Refund or Cancellation
        </h2>
        <p className="privacy-text">
          Email{" "}
          <a href="mailto:sales@mentationtech.in">sales@mentationtech.in</a>{" "}
          with your order/service ID and reason for the request.
        </p>

        <h2 className="mt-4 privacy-heading">Exclusions</h2>
        <p className="privacy-text">
          Certain services or digital products may not be refundable. Please
          review product-specific terms before purchase.
        </p>

        <h2 className="mt-4 privacy-heading">Need Help?</h2>
        <p className="privacy-text">
          Contact our support team for any questions or assistance regarding
          privacy, refunds, or services.
        </p>
      </div>
    </>
  );
}
